import { getLocalizedSearchPath } from "@/config"
import { QUERY_PARAM } from "@/mapping/url/constants"

/**
 * Navigates to the search page with the given query using SPA navigation.
 * Preserves the current locale prefix (e.g. /en-ca/, /fr-ca/) in the URL; the
 * base market with no prefix navigates to the bare /search.
 * @param query - The search query to navigate with
 * @param mode - Navigation mode, "history" for SPA navigation without reload
 */
export function searchNavigate(query: string, mode?: "history") {
  const url = new URL(getLocalizedSearchPath(), window.location.origin)
  url.searchParams.set(QUERY_PARAM, query)
  if (mode === "history") {
    window.history.pushState(null, "", url.pathname + url.search)
  } else {
    window.location.href = url.href
  }
}
